import { apiRequest } from '@/utils/api-request';
import { OrgNodeAccessConfig } from './get-org-node-access-config';

export const updateOrgConfig = async (
  orgId: string,
  items: Record<string, boolean>,
): Promise<OrgNodeAccessConfig> => {
  const response = await apiRequest<OrgNodeAccessConfig>({
    url: `/org-node-access-config/${orgId}/org`,
    method: 'PATCH',
    target: 'platform',
    body: { items },
  });

  if (response?.detail) {
    throw new Error(response.detail);
  }

  if (!response?.data) {
    throw new Error('Unexpected response format');
  }

  return response.data;
};
